import React from 'react';
const PageError = React.lazy(() => import('./pages/Pages/Special/PageError'));
const Coworking = React.lazy(() => import('./pages/Coworking/index'));
const PageBlogDetail = React.lazy(() =>
	import('./pages/Pages/Blog/PageBlogDetail'),
);
const ContactOne = React.lazy(() =>
	import('./pages/Pages/Contact/ContactOne'),
);

const routes = [
	{ path: '/page-blog-detail', component: PageBlogDetail, isTopbarDark: true },
	{ path: '/submit', component: ContactOne, isTopbarDark: true },
	{ path: '/', component: Coworking, exact: true },
	{ component: PageError, isWithoutLayout: true, exact: false },
];

export default routes;
